import {
  ChangeDetectionStrategy,
  Component,
  computed,
  output,
  signal,
} from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
interface ITapOption {
  id: number;
  title: string;
  isSelected: boolean;
  value: EHeaderTap;
}

export enum EHeaderTap {
  MATCH = 0,
  H2H = 1,
  CLASIFICACION = 2,
}

@Component({
  selector: 'app-match-header-tab-bar',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './match-header-tab-bar.component.html',
  styleUrl: './match-header-tab-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MatchHeaderTabBarComponent {
  valueTap = output<EHeaderTap>();

  selectedTap = signal<EHeaderTap>(EHeaderTap.MATCH);
  tapOption = computed<ITapOption[]>(() => [
    {
      id: 0,
      title: this.translateService.instant('Match'),
      isSelected: true,
      value: EHeaderTap.MATCH,
    },
    {
      id: 1,
      title: this.translateService.instant('H2H'),
      isSelected: false,
      value: EHeaderTap.H2H,
    },
    {
      id: 2,
      title: this.translateService.instant('Standing'),
      isSelected: false,
      value: EHeaderTap.CLASIFICACION,
    },
  ]);

  displayedTapOptions = computed(() =>
    this.tapOption().map((item) => ({
      ...item,
      isSelected: item.value === this.selectedTap(),
    }))
  );

  constructor(private readonly translateService: TranslateService) {}

  handleSetTap = (value: EHeaderTap) => {
    this.selectedTap.set(value);
    this.valueTap.emit(value);
  };
}
